// extracted by mini-css-extract-plugin
module.exports = {"confirmingContent":"stillConfirming_confirmingContent__KNlCH","confirming-busy":"stillConfirming_confirming-busy__3_HL9","notConfirmed":"stillConfirming_notConfirmed__2fwRV"};